import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import "leaflet/dist/leaflet.css";
import { useCallback, useEffect, useRef, useState } from "react";

import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { divIcon } from "leaflet";
import useWorker from "../../hooks/worker";
import useClients from "../../hooks/clients";
import BusinessIcon from "@mui/icons-material/Business";
import L from "leaflet";
import useServiceOrders from "../../hooks/service-orders";

const MapCenterer = ({
  markers,
}: {
  markers: {
    lat: number;
    lng: number;
  }[];
}) => {
  const map = useMap();

  useEffect(() => {
    if (markers.length > 0) {
      const bounds = L.latLngBounds(markers.map((m) => [m.lat, m.lng]));
      map.fitBounds(bounds, { padding: [50, 50] }); // Ajusta o zoom para incluir todos os marcadores
    }
  }, [map, markers]);

  return null;
};
const Map = () => {
  const { featWorkersList, workersWithLocation } = useWorker();
  const { featCleints, clientsWithLocation } = useClients();
  const [waitingFor, setWaitingFor] = useState<ServiceOrder[]>();
  const { get: getServiceOrders } = useServiceOrders();

  const getOrders = useCallback(() => {
    const fn = async () => {
      const resp = await getServiceOrders();

      setWaitingFor(resp.filter((item) => item.statusList.length === 1));
    };
    fn();
  }, []);

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  useEffect(() => {
    featWorkersList();
    featCleints();
  }, [featWorkersList]);

  const workerIcon = divIcon({
    html: renderToStaticMarkup(
      <div className="bg-[#0f0] w-[30px] h-[30px] rounded-full">
        <ManageAccountsIcon />
      </div>
    ),
    iconSize: [0, 0],
    iconAnchor: [15, 15],
  });
  const workerIconBusy = divIcon({
    html: renderToStaticMarkup(
      <div className="bg-[#ff0] w-[30px] h-[30px] rounded-full">
        <ManageAccountsIcon />
      </div>
    ),
    iconSize: [0, 0],
    iconAnchor: [15, 15],
  });

  const compannyIcon = (client: Client) => {
    const count = waitingFor?.filter(
      (service) => service.clientId === client.id
    ).length;
    return divIcon({
      html: renderToStaticMarkup(
        <>
          <div className="bg-[#99f] w-[30px] h-[30px] rounded-full">
            <BusinessIcon />
          </div>
          <div className="bg-[#99f] flex flex-row gap-[4px] text-nowrap rounded-[4px] p-[4px] size-min">
            {count !== undefined && count > 0 && (
              <div className="bg-[#fff] rounded-full p-[4px] size-min">
                {count}
              </div>
            )}
            {client.name}
          </div>
        </>
      ),
      iconSize: [0, 0],
      iconAnchor: [15, 15],
    });
  };
  const mapRef = useRef(null);
  const latitude = 51.505;
  const longitude = -0.09;

  useEffect(() => {
    console.log(clientsWithLocation);
    clientsWithLocation.map((client) => {
      console.log(client);
    });
  }, [clientsWithLocation]);
  return (
    // Make sure you set the height and width of the map container otherwise the map won't show
    <MapContainer
      center={[latitude, longitude]}
      zoom={13}
      ref={mapRef}
      style={{ height: "100vh", width: "100vw" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {workersWithLocation.map((worker) => {
        return (
          <Marker
            position={[
              Number(worker.currentLatitude),
              Number(worker.currentLongitude),
            ]}
            icon={
              worker.activeServiceOrder !== undefined &&
              worker.activeServiceOrder.length > 0
                ? workerIconBusy
                : workerIcon
            }
          >
            <Popup>
              {worker.name}
              <br />
              {worker.phone}
            </Popup>
          </Marker>
        );
      })}
      {clientsWithLocation.map((client) => {
        return (
          <Marker
            position={[
              Number(client.address?.geolocation._lat),
              Number(client.address?.geolocation._long),
            ]}
            icon={compannyIcon(client)}
          >
            <Popup>
              {client.name}
              <br />
              {
                waitingFor?.filter((service) => service.clientId === client.id)
                  .length
              }
            </Popup>
          </Marker>
        );
      })}
      <MapCenterer
        markers={[
          ...clientsWithLocation.map((client) => ({
            lat: Number(client.address?.geolocation._lat),
            lng: Number(client.address?.geolocation._long),
          })),
          ...workersWithLocation.map((worker) => ({
            lat: Number(worker.currentLatitude),
            lng: Number(worker.currentLongitude),
          })),
        ]}
      />
    </MapContainer>
  );
};

export default Map;
